import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Contact } from './pages/Contact';
import { initMetaPixel } from './components/utils/metaPixel';
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/terminos-y-condiciones" element={<Terms data-id="element-6" />} data-id="element-5" />
        <Route path="/politica-de-privacidad" element={<Privacy data-id="element-8" />} data-id="element-7" />
        <Route path="/contacto" element={<Contact data-id="element-10" />} data-id="element-9" />
      </Routes>
    </BrowserRouter>;
}